var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"register"},[_c('section',{staticClass:"wrapper section"},[_c('form-internal-register')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }